import { inject, Injectable } from '@angular/core';
import { BackendDataSourceService } from '@ntap/core';
import { map } from 'rxjs';

@Injectable()
export class ArhivskaKlasifikacijaProvider {
  backendDataSourceService = inject(BackendDataSourceService);

  getArhivskeOznake() {
    return this.backendDataSourceService
      .getViewData('arhivske_klasifikacije', {})
      .pipe(
        map((items) => {
          interface Item {
            [key: string]: any;
          }

          // Function to organize items into nested structure
          function organizeItems(items: Item[]) {
            const arhivskeOznakeArray: any[] = [];

            const map: { [key: string]: any } = {};
            items.forEach((item) => {
              const newItem = {
                label: `${item['sif~glavna_klasifikacija~sifra'] || ''}  ${
                  item['sif~glavna_klasifikacija~naziv'] || ''
                }`,
                data: item['sif~glavna_klasifikacija~id'],
                children: []
              };
              map[item['sif~glavna_klasifikacija~id']] = newItem;
            });

            items.forEach((item) => {
              const parentId = item['sif~glavna_klasifikacija~parent_id'];
              if (parentId !== null) {
                if (map[parentId]) {
                  map[parentId].children.push(
                    map[item['sif~glavna_klasifikacija~id']]
                  );
                  (map[parentId].children as any[]).sort((c, p) =>
                    c.label.localeCompare(p.label)
                  );
                }
              } else {
                arhivskeOznakeArray.push(
                  map[item['sif~glavna_klasifikacija~id']]
                );
              }
            });

            return arhivskeOznakeArray.sort((c, p) =>
              c.label.localeCompare(p.label)
            );
          }

          // Call the function to get the nested structure
          return organizeItems(items);
        })
      );
  }
}
